import { render, staticRenderFns } from "./Membresias.vue?vue&type=template&id=2e05e6e0"
import script from "./Membresias.vue?vue&type=script&lang=js"
export * from "./Membresias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports